import * as Haptics from 'expo-haptics'
import { Pressable, type PressableProps } from 'react-native'

export function HapticTab(props: PressableProps) {
    return (
        <Pressable
            {...props}
            onPressIn={ev => {
                if (process.env.EXPO_OS === 'ios') {
                    // Add a soft haptic feedback when pressing down on the tabs.
                    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light)
                }
                props.onPressIn?.(ev)
            }}
        />
    )
}
